import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "app/hooks";
import { Helmet } from "react-helmet-async";

//components
import { Loading } from "common/Loading";
import { ContentLayout } from "common/ContentLayout";
import { Lamps } from "./Lamps";

//actions
import { getLamps, getGroups } from "feat/objects/actions";

export const LampsPage: React.FC = () => {
  const dispatch = useAppDispatch();
  const loading = useAppSelector((state) => state.lamps.loading);

  useEffect(() => {
    dispatch(getLamps());
    dispatch(getGroups());
  }, [dispatch]);

  if (loading) {
    return <Loading />;
  }

  return (
    <>
      <Helmet>
        <title>Светильники</title>
      </Helmet>

      <ContentLayout>
        <Lamps />
      </ContentLayout>
    </>
  );
};
